import Vue from 'vue'
import {Toast, Dialog} from 'vant'
import moment from "moment";
Vue.use(Toast, Dialog)

export const TOKEN_KEY = 'token'

export const setToken = (token) => {
    localStorage.setItem(TOKEN_KEY, token)
}

export const getToken = () => {
    return localStorage.getItem(TOKEN_KEY)
}

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => {
    return targetarr.some(_ => arr.indexOf(_) > -1)
}

// 是否在微信浏览器
export const isWeixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1

// 是否为安卓系统
export const isAndroid = navigator.userAgent.toLowerCase().indexOf('android') != -1

export const appendIfNotEmpty = (data, key, value) => {
    if (!(value == null || value == undefined)) {
        data.append(key, value)
    }
}

export const util = {
    // 显示提示框
    showTips(msg, duration) {
        let obj = Toast({
            mask: false,
            message: msg,
            duration: duration == undefined ? 2000 : duration
        })
        return obj
    },
    // 显示加载提示
    showLoading(msg) {
        let obj = Toast.loading({
            mask: false,
            forbidClick: true,
            message: msg,
            duration: 0
        })
        return obj
    },
    // 隐藏加载提示
    hideLoading() {
        Toast.clear()
    },
    // 显示成功提示框
    showSuccessTips(msg, duration) {
        let obj = Toast.success({
            mask: false,
            message: msg,
            duration: duration == undefined ? 2000 : duration
        })
        return obj
    },
    // 显示模态框
    showModal(title, msg, confirmText, confirmCallback) {
        let opts = {
            message: msg,
            confirmButtonColor: '#e54d42',
        }
        if (title) {
            opts.title = title
        }
        if (confirmText) {
            opts.confirmText = confirmText
        }
        Dialog.alert(opts).then(() => {
            if (confirmCallback) confirmCallback();
        })
    },
    // 显示确认提示框
    showConfirmModal(title, msg, confirmText, confirmCallback, cancelCallback) {
        let opts = {
            showCancelButton: true,
            message: msg,
            confirmButtonColor: '#e54d42',
        }
        if (title) {
            opts.title = title
        }
        if (confirmText) {
            opts.confirmText = confirmText
        }
        Dialog.alert(opts).then(() => {
            if (confirmCallback) confirmCallback();
        }).catch(() => {
            if (cancelCallback) cancelCallback()
        })
    }
}
export const handlePromise = (promise, onSuccess, onError, onFinal) => {
    promise.then(res => {
        const data = res.data
        if (data.code === 0) {
            if (onSuccess) {
                if (typeof onSuccess === 'function') {
                    onSuccess(data)
                } else {
                    Toast.success(onSuccess)
                }
            }
        } else {
            if (onError) {
                if (typeof onError === 'function') {
                    onError(data)
                    return;
                }
            } else {
                onError = '提示'
            }
            Dialog.alert({
                title: onError,
                message: data.msg
            })
        }
    }).finally(() => {
        if (onFinal) {
            onFinal()
        }
    })
}

//替换所有包含店员或者工资的 后端返回的数据不替换
// updateData 为true 表示更新所有匹配到的 false 表示更新
export const replaceText =  (item, label, updateData) => {
    if (item.hasChildNodes()) {
        // 有子集就需要继续遍历下去
        for(let child of item.childNodes) {
            // 判断是字符串
            if (child.nodeType == Node.TEXT_NODE) {
                let childContent = child.textContent
                let flag = false
                let attrs = child.parentElement.attributes[0]
                if (childContent.indexOf('店员') != -1){
                    if (updateData) {
                        childContent = childContent.replace(/店员/g, label.clerkLabel)
                        flag = true
                    } else if ((!attrs || (attrs && attrs.name.indexOf('data') == -1))) {
                        childContent = childContent.replace(/店员/g, label.clerkLabel)
                        flag = true
                    }
                }
                if (childContent.indexOf('工资') != -1){
                    childContent = childContent.replace(/工资/g, label.salaryLabel)
                    flag = true
                }
                if (flag) {
                    child.textContent = childContent
                }
            } else {
                replaceText(child, label, updateData)
            }
        }
    }
}

// 替换input框中 placeholder 为店员以及工资的
export const replaceInput =  (item, label) => {
    let arr = item.querySelectorAll("input, .label, span")
    for(let child of arr) {
        let placeholder = ''
        let flag = false
        if (child.localName == 'input') {
            placeholder = child.placeholder
        } else {
            placeholder = child.textContent
        }
        if (placeholder.indexOf('店员') != -1) {
            placeholder = placeholder.replace(/店员/g, label.clerkLabel)
            flag = true
        }
        if (placeholder.indexOf('工资') != -1) {
            placeholder = placeholder.replace(/工资/g, label.salaryLabel)
            flag = true
        }
        if (flag) {
            if (child.localName == 'input') {
                child.placeholder = placeholder
            } else {
                child.textContent = placeholder
            }
        }
    }
}

// 替换所有包含店员、工资的标签
export const replaceAllText =  (item, label, updateData) => {
    replaceInput(item, label)
    replaceText(item, label, updateData)
}


/** 格式化日期 */
export const formatDate = (date, format) => {
    if (!date) {
        return ''
    }
    if (!format) {
        format = 'YYYY-MM-DD'
    }
    return moment(date).format(format)
}
